import { useState, useCallback } from 'react'

const WORKER_URL = 'https://bio-scraper.albertsmit.workers.dev'

/**
 * Hook for fetching scraper health probe data.
 * Tries the Pages Function first, then falls back to the Worker directly.
 */
export function useHealthProbes() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const refresh = useCallback(async () => {
    setLoading(true)
    setError(null)

    const sources = ['/api/health', `${WORKER_URL}/health/probes`]

    for (const url of sources) {
      try {
        const res = await fetch(url)
        if (!res.ok) continue

        const result = await res.json()
        setData(result)
        setLoading(false)
        return
      } catch {
        // try next source
      }
    }

    setError('Kan health data niet ophalen.')
    setLoading(false)
  }, [])

  return { data, loading, error, refresh }
}
